import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { ToastContainer, notify } from '../../libraries/notifications';
import { history } from '../../routes';
import config from '../../config';

import SearchInput from "../../components/forms/SearchInput";
import OfferOptions from '../../components/customs/OfferOptions';
import Loader from '../../components/commons/Loader';
import LayoutSmall from '../../components/layout/LayoutSmall';
import Icon from '../../libraries/icons';

import categoriesAction from '../../context/categories/actions';


class StepSearch1 extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      category: null,
      categories: [],
      categories_selected: [],
      search : '',
      type: null,
      parent: 'root',
    }
  }
  
  componentDidMount() {
    const params = this.props.match.params;
    console.log('STEP_SEARCH1', params);
    if (params.type){
      this.setState({ type: params.type }, () => this.getCategories());
    } else {
      this.goBack();
    }    
  }

  getCategories = async (next) => {
    const { type, parent, search, filters, category, categories_selected } = this.state
    const params = { type, parent }

    if (search && search !== ""){
      // params.where = { json_data: { name: search }}
      params.name = `${search.toLowerCase()}`;
      params.parent = null
    }

    console.log('LOOKING', type, parent, search);
    await this.props.onGetAllCategories(params);
    const { categories } = this.props;
    if (categories.error) { 
      notify(this.t(categories.error.message));
    } else {
      this.setState({ categories: categories.items });
      if (next && categories.items.length === 0) {
        console.log('GO NEXT', category);
        history.push({
          pathname: config.ROUTES.REQUESTS.DETAILS.replace(':type', type),
          state: {
            type,
            category,
            categories_selected
          }
        })
      }
    }    
  }

  onCategorySelect = async (category) => {
    console.log('SELECTED CATEGORY', category);
    const { categories_selected } = this.state;
    this.setState({ search: '', category, categories_selected: [...categories_selected, category], parent: category.id }, () => this.getCategories(true) );
  }


  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getCategories() );
  };


  goBack = () => history.push(config.ROUTES.ADD)


  render() {
    const { categories, type} = this.state;

    let title = ''; 

    switch (type && type){
      case config.TYPES.OFFERS.PRODUCTS:
        title = this.t("¿Qué producto necesitás?")
        break;
        case config.TYPES.OFFERS.SERVICES:
          title = this.t("¿Qué servicios necesitás?")
          break;
        case config.TYPES.OFFERS.FAVORS:
          title = this.t("¿Qué favores necesitás?")
          break;
        default: 
    }

    return (
      <LayoutSmall
        main={{ className: ""}}
        header={{ 
          left: { icon: 'arrow_left', action: this.goBack },
        }}
        container={{ className: "px-0"}}
        loading={this.props.categories.loading}
      >
        <ToastContainer/>
        <section className="bg-primary text-primary-content text-center px-3 pb-4">
          <Icon className="h-16 w-16 mx-auto mb-1" name="pin" />
          <h1>{title}</h1>
        </section>
        <section className="bg-primary-focus px-3 pt-3">
          <Form initialValues={{}} onSubmit={this.searchOnClick}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto pb-4">
                <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form) }/>
              </form>
            )}
          </Form>
        </section>
        <section className="overflow-y-auto max-w-lg mx-auto categories-vertical-wrapper">
        {/* <section className="w-full max-w-lg mx-auto"> */}
          { this.props.categories.loading && (<Loader/>) }
          {!this.props.categories.loading && categories.length === 0 && (
            <div className="text-center p-10">
              <Icon className="h-24 w-24 mx-auto mb-3" name="bell" />
              <h4 className="mb-1">{this.t("There is no categories")}</h4>
            </div>
          )}
          <div className="card white rounded-none">
            <div className="overflow-x-auto">
              { categories && categories.map((category,index) => (
                <OfferOptions 
                  key={index}
                  data={category}
                  onClick={this.onCategorySelect}
                />
              ))}
            </div>
          </div>
        </section>
      </LayoutSmall>      
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    categories : state.categories.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllCategories: (params) => dispatch(categoriesAction.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(StepSearch1));
